<template>
  <div>
    <div class="topsearch-container">
      <a-form :model="MIXINTopSearchParams" v-bind="MIXINTopSearchFormSetting">
        <a-row>
          <a-col v-bind="MIXINDefaultTopSearchSigns">
            <a-form-item label="奖品类型">
              <a-select v-model="MIXINTopSearchParams.category_id" placeholder="选择奖品类型">
                <a-select-option
                  v-for="prizeType in prizeTypeDataSource"
                  :key="prizeType.id"
                  :value="prizeType.id">
                  {{ prizeType.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col v-bind="MIXINDefaultTopSearchSigns">
            <a-form-item label="抽奖状态">
              <a-select v-model="MIXINTopSearchParams.prize_status" placeholder="选择抽奖状态">
                <a-select-option value="1">待发放</a-select-option>
                <a-select-option value="2">已发放</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- <a-col v-bind="MIXINDefaultTopSearchSigns">
            <a-form-item label="订单状态">
              <a-input v-model="MIXINTopSearchParams.type" allowClear placeholder="选择订单状态" />
            </a-form-item>
          </a-col> -->
          <a-col v-bind="MIXINDefaultTopSearchSigns" class="topsearch-submit">
            <a-button type="primary" icon="search" @click="handleTopSearchSubmit">查询</a-button>
            <a-button type="primary" icon="delete" ghost @click="handleTopSearchClear">清空</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-divider :dashed="true" class="divider--notop" />
    <div>
      <a-table
        row-key="id"
        v-bind="MIXINTableSetting"
        @change="handleTableChange">
        <template slot="operator" slot-scope="text, record">
          <a-button type="link" size="small" @click="handleOpenDialog(record)">{{ record.prize_status === 1 ? '发放' : '查看' }}</a-button>
        </template>
      </a-table>
    </div>
    <a-modal
      :title="getDialogTitle"
      :visible="dialogVisible"
      :confirm-loading="dialogConfirmLoading"
      @ok="handleOk"
      @cancel="dialogVisible = false">
      <a-form-model
        ref="dialogForm"
        :model="dialogForm"
        :rules="dialogFormRules"
        v-bind="dialogSetting">
        <a-form-model-item label="奖品类型">
          <a-input v-model="dialogForm.prize.name" :disabled="true" />
        </a-form-model-item>
        <a-form-model-item label="奖品名称">
          <a-input v-model="dialogForm.prize.category.name" :disabled="true" />
        </a-form-model-item>
        <a-form-model-item label="发放数量">
          <a-input v-model="dialogForm.num" :disabled="true" />
        </a-form-model-item>
        <a-form-model-item label="发放方式" prop="prize_type">
          <a-select v-model="dialogForm.prize_type" :disabled="isDetailsTypeDialog" placeholder="请选择发放方式">
            <a-select-option :value="1">线上发放</a-select-option>
            <a-select-option :value="2">现场发放</a-select-option>
            <a-select-option :value="3">邮寄发放</a-select-option>
          </a-select>
        </a-form-model-item>
        <template v-if="dialogForm.prize_type === 2">
          <a-form-model-item label="发放地点" prop="place">
            <a-input v-model="dialogForm.place" :disabled="isDetailsTypeDialog" placeholder="请输入发放地点" />
          </a-form-model-item>
        </template>
        <template v-if="dialogForm.prize_type === 3">
          <a-form-model-item label="快递公司" prop="express">
            <a-select v-model="dialogForm.express" :disabled="isDetailsTypeDialog" placeholder="请选择快递公司">
              <a-select-option value="圆通快递">圆通快递</a-select-option>
              <a-select-option value="申通快递">申通快递</a-select-option>
              <a-select-option value="顺丰快递">顺丰快递</a-select-option>
              <a-select-option value="德邦快递">德邦快递</a-select-option>
              <a-select-option value="韵达快递">韵达快递</a-select-option>
              <a-select-option value="中通快递">中通快递</a-select-option>
              <a-select-option value="百世汇通">百世汇通</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="快递单号" prop="express_order">
            <a-input v-model="dialogForm.express_order" :disabled="isDetailsTypeDialog" placeholder="请输入快递单号" />
          </a-form-model-item>
        </template>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import _ from 'lodash'
import api from '@/api/'
import { ReuseMixin } from '../mixins/reuse'

// 奖品发放方式
const prize_type = { 1: '线上发放', 2: '现场发放', 3: '邮寄发放' }

const tableColumns = [
  { title: 'ID', dataIndex: 'id' },
  { title: '奖品名称', dataIndex: 'prizeName', customRender: (_, record) => record.prize.name },
  { title: '奖品类型', dataIndex: 'prizeType', customRender: (_, record) => record.prize.category.name },
  { title: '中奖数量', dataIndex: 'num' },
  { title: '中奖时间', dataIndex: 'created_at' },
  // { title: '关联订单', dataIndex: 'time3' },
  { title: '中奖人员', dataIndex: 'person', customRender: (_, record) => {
    return record.number ? `${record.name}(${record.number})` : record?.userInfo?.username ? record?.userInfo?.username : '--'
  }
  },
  // { title: '订单状态', dataIndex: 'time5' },
  { title: '发放状态', dataIndex: 'prize_status', customRender: (_, record) => record.prize_status ? record.prize_status === 1 ? '待发放' : '已发放' : '-' },
  { title: '发放方式', dataIndex: 'type',
    customRender: (_, record) => record.prize_type ? prize_type[record.prize_type] : '-' },
  { title: '操作', dataIndex: 'operator', width: 100,
    scopedSlots: { customRender: 'operator' }
  }
]

export default {
  name: 'ActivityClaim',
  mixins: [ReuseMixin],
  data() {
    return {
      dialogVisible: false,
      dialogConfirmLoading: false,
      pitchOnDialogType: 1,
      dialogForm: { prize: { category: { name: '' }, name: '' }, prize_type: undefined, place: '', express: undefined, express_order: '' },
      dialogFormRules: {
        prize_type: [
          { required: true, message: '请选择发放方式', trigger: 'change' }
        ],
        place: [
          { required: true, message: '请输入发放地点', trigger: 'blur' }
        ],
        express: [
          { required: true, message: '请选择快递公司', trigger: 'change' }
        ],
        express_order: [
          { required: true, message: '请输入快递单号', trigger: 'blur' }
        ],
      },
      dialogSetting: { labelCol: { span: 5 }, wrapperCol: { span: 17 } },
      prizeTypeDataSource: []
    }
  },
  computed: {
    getDialogTitle() {
      switch (this.pitchOnDialogType) {
        case 1:
          return '奖品发放'
        case 2:
          return '中奖详情'
        default:
          return ''
      }
    },
    isDetailsTypeDialog() {
      return this.pitchOnDialogType === 2
    }
  },
  methods: {
    // prize_status: 1 => 待发放 2 => 已发放
    handleOpenDialog(record) {
      this.pitchOnDialogType = record.prize_status
      this.dialogForm = _.cloneDeep({ ...record, prize_type: record.prize_type || undefined })
      this.dialogVisible = true
    },
    async handleOk() {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          const isIssue = this.pitchOnDialogType === 1
          this.dialogConfirmLoading = true
          try {
            if (isIssue) {
              const { code } = await api.updateActivitiesPrizeClaim(this.dialogForm)
              if (code === '000000') {
                this.$notification.success({
                  message: '操作成功',
                  description: `奖品【${this.dialogForm.prize.name}】已成功发放`,
                })
                this.MIXINHandleRefreshTable(this.fetchOriginList)
                this.dialogVisible = false
              }
              this.dialogConfirmLoading = false
            } else {
              this.dialogVisible = false
            }
          } catch {
            this.dialogConfirmLoading = false
          }
        } else {
          return false
        }
      })
    },
    async fetchPrizeTypeDataSource() {
      const { code, data } = await api.fetchPrizeTypeList({ page: 1, per_page: 2000 })
      this.prizeTypeDataSource = code === '000000' ? data.category : []
    },
    async fetchOriginList() {
      const DefaultPagination = { page: 1, per_page: 10, total: 0 }
      try {
        const { code, data } = await api.fetchActivitiesPrizeClaimList(this.MIXIXGetTableTransferAllParams())
        const isSucceed = code === '000000'
        return {
          list: isSucceed ? data.record : [],
          pagination: isSucceed ? data.pagination : { ...DefaultPagination }
        }
      } catch {
        return { list: [], pagination: { ...DefaultPagination } }
      }
    },
    handleTopSearchSubmit() {
      this.MIXINSaveTopSearchParamsToStorage(() => this.MIXINHandlePageChange(this.fetchOriginList, 1))
    },
    handleTopSearchClear() {
      this.MIXINClearTopSearchParams(() => this.MIXINHandlePageChange(this.fetchOriginList, 1))
    },
    handleTableChange({ current, pageSize }) {
      this.MIXINHandlePageChange(this.fetchOriginList, current, pageSize)
    },
  },
  created() {
    this.MIXINInit({
      beforeInit: () => this.fetchPrizeTypeDataSource(),
      tableColumns: tableColumns,
      topSearchParams: { prize_status: undefined, category_id: undefined, activity_id: this.$route.params.id },
      afterInit: () => this.MIXINHandlePageChange(this.fetchOriginList, 1)
    })
  },
}
</script>

<style scoped lang="less">
@import url(../style/public.less);
</style>
